import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class StreamEndpoint extends BaseEndpoint {}
